import { Typography } from '@material-ui/core';
import { ColDef } from '@material-ui/data-grid';
import { useEffect, useState } from 'react'
import DataTable from '../../components/DataTable';
import api from '../../config/api'
import { Container } from './styles'
import { useHistory } from 'react-router-dom'
import Loading from '../../components/Loading';
import * as yup from 'yup'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { CheckBox } from './styles';
import { toast } from 'react-toastify'
import {
    Button,
    TextField,
} from '@material-ui/core'
import { Height } from '@material-ui/icons';

interface Link {
    id: number
    name: string
    url: string
    logo: string
}

function Links() {

    const [loading, setLoading] = useState(false)
    const [links, setLinks] = useState<Link[]>([])
    const [updatedLink, setUpdateLinks] = useState<Link[]>([])
    const [registering, setRegistering] = useState(false)
    const [cola, setCola] = useState(false)
    const [coop, setCoop] = useState(false)
    const [safari, setSafari] = useState(false)
    const [chrome, setChrome] = useState(false)
    const [vpn, setVpn] = useState(false)
    const [logo, setLogo] = useState(false)
    const [hasLogo, setHasLogo] = useState(false)
    const [name, setName] = useState('')
    const [url, setUrl] = useState('')

    let history = useHistory();


    useEffect(() => {
        setLoading(true)
        async function fetch() {
            const response = await api.get('/links/list')
            setLinks(response.data.links)
            setUpdateLinks(response.data.links)
            setLoading(false)
        }
        fetch()
    }, [])

    async function setInfo() {
        setRegistering(true)
    }



    function handleClick(row: any) {
    }

    const columns: ColDef[] = [
        { field: 'id', headerName: 'ID', width: 20 },
        { field: 'name', headerName: 'Nome', width: 300 },
        { field: 'url', headerName: 'URL', width: 300 },
        { field: 'cola', headerName: 'Colaboradores', width: 200 },
        { field: 'coop', headerName: 'Coop', width: 200 },
        { field: 'safari', headerName: 'Safari', width: 200 },
        { field: 'chrome', headerName: 'Chrome', width: 200 },
        { field: 'vpn', headerName: 'VPN', width: 200 },
        { field: 'logo', headerName: 'Logo', width: 200 },
        { field: 'hasLogo', headerName: 'Tem Logo', width: 200 },
    ];

    const formCreateScheme = yup.object().shape({
        name: yup.string().required('É necessário informar o nome do link'),
        url: yup.string().required('É necessário informar a URL do link')
    })
    const { register, handleSubmit, formState: { errors }, reset } = useForm<{ name: number, url: string, cola: boolean, coop: boolean, safari: boolean, chrome: boolean, vpn: boolean, logo: boolean, hasLogo: boolean }>({
        resolver: yupResolver(formCreateScheme)
    })

    async function handleSubmitForm({ name, url, cola, coop, safari, chrome, vpn }: { name: string, url: string, cola: boolean, coop: boolean, safari: boolean, chrome: boolean, vpn: boolean, logo: boolean, hasLogo: boolean }) {
        console.log(`INSERT INTO public.links (name, url, cola, coop, safari, chrome, vpn, logo, hasLogo) VALUES('${name}', '${url}', '${cola}', '${coop}', '${safari}', '${chrome}', '${vpn}', '${logo}', '${hasLogo}');`)
        try {
            const responseLinks = await api.post(`/links/create`, { name, url, cola, coop, safari, chrome, vpn, logo, hasLogo })
            const { link } = responseLinks.data
            reset()
            toast.success("Link criado com sucesso!")
            setRegistering(false)
        } catch (err) {
            if (err instanceof Error) {
                toast.error(err.message)
            } else
                toast.error('Erro desconhecido!')
        }
    }



    return (
        <>
            <Container>
                {
                    loading ?
                        <Loading />
                        :
                        <>
                            <Typography variant="h4" style={{ marginBottom: 0, fontWeight: 600 }}>
                                Links
                            </Typography>
                            {registering ?

                                <>
                                <strong>Atenção, Links que serão abertos no Microsoft Edge, deve conter microsoft-edge- antes do inicio da URL por exemplo microsoft-edge-https://placecon.com.br</strong>
                                    <form onSubmit={handleSubmit(handleSubmitForm)}>
                                        <TextField
                                            autoComplete="fname"
                                            variant="outlined"
                                            id="name"
                                            label="Nome do Link"
                                            {...register('name')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                        />
                                        <TextField
                                            autoComplete="fname"
                                            variant="outlined"
                                            id="url"
                                            label="URL do Link"
                                            {...register('url')}
                                            autoFocus
                                            error={errors.url ? true : false}
                                        />
                                        </form>
                                        <form onSubmit={handleSubmit(handleSubmitForm)}>
                                        <TextField
                                            type={'checkbox'}
                                            autoComplete="fname"
                                            id="cola"
                                            {...register('cola')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                            style={{ width: 60, margin: 5 }}
                                        />
                                        Rede Colaboradores
                                        <TextField
                                            type={'checkbox'}
                                            autoComplete="fname"
                                            id="coop"
                                            {...register('coop')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                            style={{ width: 60, margin: 5 }}
                                        />
                                        Rede Coop
                                        <TextField
                                            type={'checkbox'}
                                            autoComplete="fname"
                                            id="safari"
                                            {...register('safari')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                            style={{ width: 60, margin: 5 }}
                                        />
                                        Safari
                                        <TextField
                                            type={'checkbox'}
                                            autoComplete="fname"
                                            id="chrome"
                                            {...register('chrome')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                            style={{ width: 60, margin: 5 }}
                                        />
                                        Chrome
                                        <TextField
                                            type={'checkbox'}
                                            autoComplete="fname"
                                            id="vpn"
                                            {...register('vpn')}
                                            autoFocus
                                            error={errors.name ? true : false}
                                            style={{ width: 60, margin: 5 }}
                                        />
                                        VPN
                                        <Button
                                            onClick={setInfo}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            children="Cadastrar"
                                            style={{ width: 350, margin: 5 }}
                                        ></Button>
                                    </form>
                                </>
                                :
                                <>
                                    <Button
                                        onClick={setInfo}
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        children="Cadastrar um novo Link"
                                    ></Button>
                                    <DataTable columns={columns} rows={updatedLink} handleClick={handleClick} />
                                </>
                            }
                        </>
                }
            </Container>
        </>
    );
}

export default Links